import { useCallback } from 'react';
import { useGtmService } from '@funtech-int/yango-shared';

import { useLogger } from '@/shared/hooks/useLogger';

import { emitServiceMetrika } from '../lib/metrika/emitter';

export const useSendWebAnalytics = () => {
    const gtmService = useGtmService();
    const logger = useLogger();

    return useCallback(
        (target: string, params?: Record<string, unknown>) => {
            emitServiceMetrika({ target, params, logger });
            gtmService?.send({ ...params, event: target });
        },
        [gtmService, logger]
    );
};
